import {_utils, viewportChecker} from "../../../utils/_utils.js";
import {_state} from "../../../state/state.js";
import {_libs} from "../../../utils/_libs.js";

export const otherWhyChooseBlock = () => {
    return new Promise((resolve, reject) => {
        _utils.initSection('.other-why-choose', (section, sectionIndex) => init(section, sectionIndex));
        resolve();
    })
}

const init = (section, sectionIndex) => {
    const sliderDesk = section.querySelector('.other-why-choose__services');

    let swiper = null;

    const createSwiper = () => {

        if (swiper !== null) {
            swiper.destroy(true, true);
            swiper = null;
        }

        if (!_state.isDesktop) {
            if (!swiper) {
                swiper = _libs._swiper(sliderDesk, {
                    slidesPerView: 1.1,
                    speed: 800,
                    spaceBetween: 16,
                    keyboard: {
                        enabled: true,
                    },
                    autoHeight: true,
                    autoplay: {
                        enabled: false,
                        delay: 6000,
                        disableOnInteraction: false,
                    },

                    breakpoints: {
                        768: {
                            slidesPerView: 2,
                        }
                    },

                });

            }
        }
    }

    createSwiper();

    const rebuildFunc = () => {
        createSwiper();
    }
    _utils.rebuildComponentsOnResize(rebuildFunc);
}